import React, { Component } from 'react';
import PropTypes from 'prop-types';

class EmailLinkWithSubjectAndBody extends Component {
  emailSubject() {
    return `Subject=${this.props.emailSubject}`;
  }

  emailBody() {
    const { emailBody } = this.props;
    const [ first, ...rest ] = emailBody;

    return [`body=${first}`, ...rest].join('\n');
  }

  emailSubjectAndBody() {
    return [this.emailSubject(), this.emailBody()];
  }

  linkAttributes() {
    const encodedParameters = encodeURI(this.emailSubjectAndBody().join("&"));

    return {
      href: `mailto:${this.props.email}?${encodedParameters}`,
      target:"_blank",
      rel: "noopener noreferrer"
    };
  }

  renderEmailOrLabel() {
    const { email, label } = this.props;

    if (email) {
      return (
        <a {...this.linkAttributes(this.props)} >
          {label}
        </a>
      );
    } else {
      return label;
    }
  }

  render() {
    return (
      <span>
        {this.props.message}
        {this.renderEmailOrLabel()}
      </span>
    );
  }
}

EmailLinkWithSubjectAndBody.propTypes = {
  email: PropTypes.string,
  emailBody: PropTypes.array,
  emailSubject: PropTypes.string.isRequired,
  label: PropTypes.string,
  message: PropTypes.string,
};

EmailLinkWithSubjectAndBody.defaultProps = {
  emailBody: [],
  label: "Account Manager:"
};

export default EmailLinkWithSubjectAndBody;
